import { render, staticRenderFns } from "./AlertPopups.vue?vue&type=template&id=089fe443&"
import script from "./AlertPopups.vue?vue&type=script&lang=js&"
export * from "./AlertPopups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports